import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from '../../helper/constants';
import { Global } from '../../../../app.global';
import { GlobalObservables } from '../../../../app.global.observer';
import { ReasonService } from '../../services/reason.service';
import { ReasonModel } from '../../viewmodels/reason.model';
import { PcnModel } from '../../viewmodels/pcn.model';
import { SearchSynonymsModel } from '../../viewmodels/searchSynonyms.model';
import { debounceTime, SubscriptionLike as ISubscription, Subject, Subscription } from 'rxjs';
import {
  Select2UpdateEvent,
  Select2,
  Select2SearchEvent,
  Select2Option,
} from '../../../../../../projects/ng-select2-component/src/public_api';
import { SettingsService } from '../../../../authentication/services/settings.service';
import { UserSettingsService } from '../../services/settings.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'reasons',
  templateUrl: './reasons.component.html',
  styleUrls: ['./reasons.component.scss'],
})
export class ReasonsComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onScrollToQuestions = new EventEmitter();
  @ViewChild('select2Form') reasonsForm: NgForm;
  @ViewChild('reasonSearcher') reasonSearcherComponent: Select2;

  public constants = Constants;
  reasonsUnformattedList: Array<ReasonModel>;
  public reasonsObject = [];
  public reasonsList: Array<any> = [];
  reason: any;
  public selectedReasons = [];
  selectedReasonsLock = false;
  public selectedReasonsFormatted: Array<ReasonModel>;
  recentReasons = [];
  topReasons = [];
  browseReasons = [];
  selectedReasonsCategory = 'top';
  browseReasonsSelectedCategory: any;
  hidePcnAllFields = false;
  loadingState = false;
  isCustomLettersVisible = false;
  isCustomParagraphsVisible = false;
  topMostUsedReasonCount = 10;
  browseCatEventType = 'mouseenter';
  browseCatActiveClickId = 0;
  // public fineNowChangedMessage = false;
  // disableReasonBlock = false;
  hasPreselectedReasons = false;
  searchSynonyms: Array<SearchSynonymsModel> = [];

  reasonSearchData: Array<Select2Option> = [];

  isNexusEnabled = false;
  globalNexusEnabled = false;
  userNexusEnabled = false;

  isInitialReasonLoad = false; // DC: this is nasty but necessary until we can figure out a better way to determine if reasons have changed

  /* Global Observables Subscriptions */
  private onPcnChangedEvent: ISubscription;
  private onPcnChangingEvent: ISubscription;
  // private onQuestionsChangingEvent: ISubscription;
  // private onQuestionsChangedEvent: ISubscription;
  // private onLetterChangingEvent: ISubscription;
  // private onLetterChangedEvent: ISubscription;
  private subscriptions: Subscription[] = [];
  private reasonSelection$ = new Subject<Select2UpdateEvent>();

  constructor(
    private reasonService: ReasonService,
    private settingsService: SettingsService,
    private userSettingsService: UserSettingsService,
    private router: Router,
    public global: Global,
    public globalObs: GlobalObservables
  ) {}

  ngOnInit() {
    this.selectedReasonsFormatted = this.global.SELECTED_REASONS;
    // this.onPcnChanged();

    /* Subscribe to events */
    // this.onQuestionsChangingEvent = this.globalObs.onQuestionsChanging.subscribe(() => this.onQuestionsChanging());
    // this.onQuestionsChangedEvent = this.globalObs.onQuestionsChanged.subscribe(() => this.onQuestionsChanged());
    // this.onLetterChangingEvent = this.globalObs.onLetterChanging.subscribe(() => this.onLetterChanging());
    // this.onLetterChangedEvent = this.globalObs.onLetterChanged.subscribe(() => this.onLetterChanged());
    this.onPcnChangingEvent = this.globalObs.onPcnChanging.subscribe(() => this.onPcnChanging());
    this.onPcnChangedEvent = this.globalObs.onPcnChanged.subscribe((pcn: PcnModel) =>
      this.onPcnChanged(pcn)
    );

    /* Initialise Debounced Functions */
    this.subscriptions.push(
      this.reasonSelection$
        .pipe(debounceTime(1000))
        .subscribe(this.handleReasonSelection.bind(this))
    );

    // this.onResetPcnEvent = this.globalObs.onResetPcn.subscribe(this.onPcnReset);

    this.getReasons(this.global.PCN);
    this.onCustomLetterShow();
    this.onCustomParagraphShow();

    this.settingsService.getApplicationSetting('NexusEnabled').subscribe((result) => {
      this.globalNexusEnabled = this.checkNexusEnabled(result);
      this.isNexusEnabled = this.globalNexusEnabled && this.userNexusEnabled;
    });

    this.userSettingsService.getUserSetting('nexusEnabled').subscribe((result) => {
      this.userNexusEnabled = this.checkNexusEnabled(result);
      this.isNexusEnabled = this.globalNexusEnabled && this.userNexusEnabled;
    });
  }

  onPcnChanging() {
    // console.log('[Reasons Component] PCN Changing: resetting reasons');
    this.resetReasons();
  }

  onPcnChanged(PCN: PcnModel) {
    this.hidePcnAllFields = true;
    // this.resetReasons();
    this.loadingState = false;

    if (PCN?.pcn) {
      // ✅ Check if PCN is valid before processing
      this.getReasons(PCN);
      this.hidePcnAllFields = false;
    }
  }

  checkNexusEnabled(v: unknown): boolean {
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      return s === 'true' || s === '1';
    }
    if (typeof v === 'number') {
      return v === 1;
    }
    if (typeof v === 'boolean') {
      return v;
    }
    return false;
  }

  // onQuestionsChanging() {
  //   this.disableReasonBlock = true;
  //   //console.log('[Reasons Component] Questions Changing: Disabling reasons block');
  // }

  // onQuestionsChanged() {
  //   this.disableReasonBlock = false;
  //   //console.log('[Reasons Component] Questions Changing: Enabling reasons block');
  // }

  // onLetterChanging() {
  //   this.disableReasonBlock = true;
  //   //console.log('[Reasons Component] Letter Changing: Disabling reasons block');
  // }

  // onLetterChanged() {
  //   this.disableReasonBlock = false;
  //   //console.log('[Reasons Component] Letter Changed: Enabling reasons block');
  // }

  scrollToQuestions() {
    this.onScrollToQuestions.emit({});
  }

  resetReasons() {
    // trigger on reasons changing
    this.globalObs.onReasonsChanging.next(true);
    // reset the selected reasons
    this.global.resetSelectedReasons();
    // call the api service to reset the reasons
    this.reasonService.setReasons([]);
    // reset local variables
    this.selectedReasons = [];
    this.selectedReasonsFormatted = [];
    this.reasonsUnformattedList = [];
    this.reasonsObject = [];
    this.reasonsList = [];
    // trigger on reasons changed
    this.globalObs.onReasonsChanged.next(true);
  }

  getReasons(PCN: PcnModel) {
    // console.log('Getting ALL reasons for PCN:', PCN.pcn);
    this.reasonService.getReasons(PCN.pcn).subscribe((reasonUnformattedList) => {
      if (reasonUnformattedList) {
        this.reasonsUnformattedList = reasonUnformattedList;
        this.generateReasonsObject(reasonUnformattedList);
        this.setSelectedReasons(this.selectedReasonsFormatted);
        this.createReasonsList();
        this.setAllReasons();
        this.browseReasonsSelectedCategory = this.reasonsObject[0]['subcategories'];
        this.browseReasons[0]['active'] = true;
        this.getSelectedReasons(PCN);
      }
    });
  }

  getSelectedReasons(PCN: PcnModel) {
    this.reasonService.getSelectedReasons(PCN.pcn).subscribe({
      next: (selectedReasons) => {
        if (selectedReasons.length > 0) {
          // console.log('Selected reasons:', JSON.stringify(selectedReasons));
          this.reasonService.setLocalReasons(selectedReasons);
          // this.global.REASONS = selectedReasons;
          // fire the event to notify that selected reasons have changed
          this.globalObs.onReasonsChanged.next(selectedReasons);
          this.selectedReasons = [];
          this.hasPreselectedReasons = true;
          selectedReasons.forEach((reason) => {
            this.selectedReasons.push(reason.id.toString());
          });
        }
      },
      error: (e) => {
        console.log(e);
      },
      complete: () => {
        this.openDefaultOnFirstLoad();
      },
    });
  }

  setSelectedReasons(reasons) {
    // console.log('Setting selected reasons:', JSON.stringify(reasons));
    if (reasons.length > 0) {
      reasons.forEach((reason) => {
        this.selectedReasons.push(reason.id.toString());
      });
    }
  }

  generateReasonsObject(result) {
    this.reasonsObject = this.reasonService.generateReasonsObject(result);
  }

  createReasonsList() {
    this.reasonsList = this.reasonService.createReasonToList(this.reasonsObject);

    this.reasonSearchData = [];

    this.reasonsList.forEach((reason) => {
      const searchSynonymsModel = new SearchSynonymsModel(); // Creating a new instance
      searchSynonymsModel.representationItemCategorisationId = reason.id; // Assigning reason.Id to representationItemCategorisationId
      searchSynonymsModel.reasonName = reason.text; // Assigning reason.name to reasonName
      searchSynonymsModel.synonyms = reason.synonyms; // Assigning synonyms to synonyms array

      // Pushing the created instance into the searchSynonymsList array
      this.searchSynonyms.push(searchSynonymsModel);

      // Create a new Select2Data object
      const newSelect2Data: Select2Option = {
        label: reason.text,
        value: reason.id,
        data: reason,
      };
      this.reasonSearchData.push(newSelect2Data);
    });
  }

  // Sets the recent, top and browse reasons
  setAllReasons() {
    this.setRecentReasons();
    this.setTopReasons();
    this.setBrowseReasons();
  }

  /* Populate the Recent Reasons menu */
  setRecentReasons() {
    this.reasonService
      .getMostRecentReasons(this.global.PCN.pcn, this.topMostUsedReasonCount)
      .subscribe({
        next: (reasons) => {
          let recentReasonsList = [];
          if (reasons.length > 0) {
            this.reasonsList.forEach((reason) => {
              if (reasons.indexOf(parseInt(reason.id, 10)) > -1) {
                recentReasonsList.push(reason);
              }
            });
          } else {
            recentReasonsList = this.reasonsList.slice(0, 10);
          }
          this.setFormatRecentReasons(recentReasonsList);
        },
        error: () => {
          const recentReasonsList = [];
          this.setFormatRecentReasons(recentReasonsList);
        },
      });
  }
  setFormatRecentReasons(reasonsList) {
    this.recentReasons = [];
    if (this.selectedReasons.length === 0) {
      this.recentReasons = reasonsList;
      return;
    }
    reasonsList.forEach((reason) => {
      if (this.selectedReasons.indexOf(String(reason.id)) === -1) {
        this.recentReasons.push(reason);
      }
    });
  }

  /* Populate the Top Reasons menu */
  setTopReasons() {
    this.reasonService
      .getTopContraventionRICs(this.global.PCN.pcn, this.topMostUsedReasonCount)
      .subscribe({
        next: (reasons) => {
          let reasonListTop = [];
          if (reasons.length > 0) {
            this.reasonsList.forEach((reason) => {
              if (reasons.indexOf(parseInt(reason.id, 10)) > -1) {
                reasonListTop.push(reason);
              }
            });
          } else {
            reasonListTop = this.reasonsList.slice(0, 10);
          }
          this.setFormatTopReasons(reasonListTop);
        },
        error: (e) => {
          console.log(e);
          const reasonListTop = [];
          this.setFormatTopReasons(reasonListTop);
        },
      });
  }
  setFormatTopReasons(reasonsList) {
    this.topReasons = [];
    if (this.selectedReasons.length === 0) {
      this.topReasons = reasonsList;
      return;
    }
    reasonsList.forEach((reason) => {
      if (this.selectedReasons.indexOf(String(reason.id)) === -1) {
        this.topReasons.push(reason);
      }
    });
  }

  setBrowseReasons() {
    this.browseReasons = this.reasonsObject;
    const DEFAULT_CAT_ID = 1005;
    const cat = this.browseReasons.find((c) => c.id === DEFAULT_CAT_ID);

    if (cat) {
      this.selectBrowseReasonCategory({ type: 'click' } as any, cat);
      this.setActiveClickBrowseCat(cat.id);
    }
  }

  addReason(reason) {
    if (this.isReasonSelected(reason)) {
      return;
    }
    if (
      reason.subcategories !== undefined ||
      (reason.isPermitted !== undefined && !reason.isPermitted)
    ) {
      return;
    }
    if (this.selectedReasons.indexOf(String(reason.id)) === -1) {
      this.selectedReasons.push(String(reason.id));
      this.selectedReasons = this.selectedReasons.slice();
    }
    this.onSelectedReasonsChange();
    this.setAllReasons();
  }

  isReasonSelected(reason) {
    return this.selectedReasons.indexOf(reason.id.toString()) > -1;
  }

  onSelectReasons(event: Select2UpdateEvent) {
    // console.log('Reasons changing', event);
    // trigger on reasons changing to enable locks
    this.globalObs.onReasonsChanging.next(true);

    // handle debounce of reasons selection
    this.reasonSelection$.next(event);
  }
  // onSelectReasons(event: Select2UpdateEvent) {
  //   if (this.selectedReasons === null) {
  //     this.selectedReasons = [];
  //   }

  //   if (this.selectedReasonsLock === false) {
  //     this.selectedReasonsLock = true;
  //     setTimeout(() => {
  //       //const reasonIds = Array.isArray(event.value) ? event.value : [event.value];
  //       this.updateSelectedReasons(/*reasonIds*/);
  //       this.onSelectedReasonsChange();
  //       this.setAllReasons();

  //       this.selectedReasonsLock = false;
  //     }, 1000);
  //   }
  // }

  // Updates the selected reasons through API
  updateSelectedReasons(/* reasonIds: Array<string>*/) {
    this.reasonService.updateReasons(this.global.PCN.pcn, this.selectedReasons).subscribe({
      next: (result) => {
        if (result) {
          if (this.reasonSearcherComponent.isOpen === true) {
            this.reasonSearcherComponent.toggleOpenAndClose();
          }
          this.globalObs.onReasonsChanged.next(null);
        }
      },
      error: () => {},
    });
  }

  onReasonsSearch(event: Select2SearchEvent) {
    event.filteredData(
      event.search
        ? event.data.filter((option) => {
            // convert search and label to lowercase to handle case-sensitivity
            const searchTerm = event.search.toLowerCase();
            const label = option.label.toLowerCase();
            // check if the label or any synonym contains the search term
            return (
              label.includes(searchTerm) ||
              (option.data.synonyms &&
                option.data.synonyms.some((synonym) => synonym.toLowerCase().includes(searchTerm)))
            );
          })
        : event.data
    );
  }

  onSelectedReasonsChange() {
    this.globalObs.onReasonsChanging.next(true);

    if (this.loadingState) {
      return;
    }

    this.loadingState = true;
    this.selectedReasonsFormatted = [];

    this.reasonsUnformattedList.forEach((reason) => {
      if (this.selectedReasons.indexOf(reason.id.toString()) > -1) {
        this.selectedReasonsFormatted.push(reason);
      }
    });

    this.pushSelectedReasons();

    if (this.hasPreselectedReasons) {
      // trigger on reasons changed event
      this.globalObs.onReasonsChanged.next(true);
      // set loading state to false
      this.loadingState = false;
      // reset the preselected reasons flag
      this.hasPreselectedReasons = false;
    } else {
      // there has been no change to reasons
      this.loadingState = false;
    }
  }

  pushSelectedReasons() {
    this.reasonService.setLocalReasons(this.selectedReasonsFormatted);
    // this.global.REASONS = this.selectedReasonsFormatted;
    // fire the event to notify that selected reasons have changed
    this.globalObs.OnSelectedReasonsUpdated.next(this.selectedReasonsFormatted);
  }

  getAddedReason() {
    const reasonsList = [];
    let reasonId = 0;
    this.selectedReasonsFormatted.forEach((reason) => {
      if (reasonsList.indexOf(reason.id) < 0) {
        reasonId = reason.id;
      }
    });
    return reasonId;
  }

  getRemovedReason() {
    const reasonsList = [];
    const reasonId = 0;
    this.selectedReasonsFormatted.forEach((reason) => {
      reasonsList.push(reason.id);
    });
    return reasonId;
  }

  onCustomLetterShow() {
    this.globalObs.onCustomLettersShow.subscribe((customLetter) => {
      this.isCustomLettersVisible = customLetter['visibility'];
    });
  }

  onCustomParagraphShow() {
    this.globalObs.onCustomParagraphsShow.subscribe((customParagraph) => {
      this.isCustomParagraphsVisible = customParagraph['visibility'];
    });
  }

  selectBrowseReasonCategory(event, catObj) {
    if (event.type === 'mouseenter' && this.browseCatEventType !== 'mouseenter') {
      return;
    }
    if (event.type === 'click') {
      this.browseCatEventType = 'click';
    }
    this.browseReasons.forEach((cat) => {
      cat.active = cat.caption === catObj.caption;
    });
    this.browseReasonsSelectedCategory = catObj['subcategories'];
  }

  setActiveClickBrowseCat(catId) {
    if (catId === this.browseCatActiveClickId) {
      this.browseCatEventType = 'mouseenter';
      this.browseCatActiveClickId = 0;
    } else {
      this.browseCatActiveClickId = catId;
    }
  }

  propertyExists(prop) {
    return typeof prop !== 'undefined';
  }

  isReasonSubCatSelected(reasonSubCat) {
    return (
      this.isReasonSelected(reasonSubCat) ||
      typeof reasonSubCat.isPermitted === 'undefined' ||
      !reasonSubCat.isPermitted
    );
  }

  ngOnDestroy() {
    this.onPcnChangingEvent.unsubscribe();
    this.onPcnChangedEvent.unsubscribe();
    // this.onQuestionsChangingEvent.unsubscribe();
    // this.onQuestionsChangedEvent.unsubscribe();
    // this.onLetterChangingEvent.unsubscribe();
    // this.onLetterChangedEvent.unsubscribe();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private handleReasonSelection(event: Select2UpdateEvent) {
    this.updateSelectedReasons();
    this.onSelectedReasonsChange();
    this.setAllReasons();
  }

  private openDefaultOnFirstLoad() {
    if (this.selectedReasons?.length) {
      return;
    }
    this.selectedReasonsCategory = 'browse';
    const cat = this.reasonsObject?.find((c) => c.id === 1005);
    if (cat) {
      this.selectBrowseReasonCategory({ type: 'click' } as any, cat);
      this.setActiveClickBrowseCat(cat.id);
    }

    const reason = this.findReasonById(cat ?? { subcategories: this.reasonsObject }, 1005);
    if (reason) {
      this.addReason(reason);
    }
  }

  private findReasonById(node: any, id: number): any | null {
    if (!node) {
      return null;
    }
    if (node.id === id) {
      return node;
    }
    const subs: any[] = node.subcategories || [];
    for (const child of subs) {
      const found = this.findReasonById(child, id);
      if (found) {
        return found;
      }
    }
    return null;
  }
}
